module.exports = __webpack_public_path__ + "media/components/Switch/off-94a5a200dd50958e11a2e30fe1ba373244b85e0126a5721cb0a390a2c9ad598f.svg";